import { useEffect } from "react";
import { Link } from "react-router-dom";
import { AddHeader } from "../../components/AddHeader";
import { useTranslation } from "react-i18next";
import {
  EULA_VERSION,
  PRIVACY_CONTACT,
  PING4ALL_ADDRESS,
} from "../../constants/legalPolicy";
import { LegalFooter } from "../../components/legal/LegalFooter";
import "./PrivacyNotice.css";

export default function EulaPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("eulaTitle", "End-user licence (mobile apps)") + " · SmartTT";
  }, [t]);

  return (
    <div className="terms-page">
      <AddHeader title={t("eulaTitle", "End-user licence (mobile apps)")} />
      <article className="terms-page__body">
        <p className="terms-page__meta">
          {t("privacyVersion", "Version")} {EULA_VERSION}
          {" · "}
          {t("termsUpdated", "Last updated 31 August 2026")}
        </p>
        <p>
          {t(
            "eulaIntro",
            "This EULA applies when you download or use SmartTT on iOS or Android. It is a licence agreement between you and Ping4All,"
          )}{" "}
          {PING4ALL_ADDRESS}.{" "}
          {t(
            "eulaAlsoApply",
            "The Terms of use and the Privacy notice also apply. If this EULA and an app-store agreement conflict about your use of SmartTT, this EULA prevails."
          )}
        </p>

        <h2>{t("eulaLicenseTitle", "Licence")}</h2>
        <p>
          {t(
            "eulaLicenseBody",
            "If you follow this EULA, Ping4All grants you a personal, revocable, non-exclusive, non-transferable, non-sublicensable licence to install SmartTT on a device allowed by the Apple App Store or Google Play, and to use it for club training — not to copy, sell, or reverse-engineer the app. Ping4All and its licensors keep all other rights. Ping4All may change, suspend or interrupt the app."
          )}
        </p>

        <h2>{t("eulaStoresTitle", "Apple and Google")}</h2>
        <ul>
          <li>
            {t(
              "eulaStores1",
              "The licence is limited to devices that run iOS or Android, under the store's usage rules."
            )}
          </li>
          <li>
            {t(
              "eulaStores2",
              "Maintenance and support for SmartTT are Ping4All's responsibility, not Apple's or Google's."
            )}
          </li>
          <li>
            {t(
              "eulaStores3",
              "Apple and Google are third-party beneficiaries of this EULA and may enforce it against you."
            )}
          </li>
        </ul>

        <h2>{t("eulaContentTitle", "Your content")}</h2>
        <p>
          {t(
            "eulaContentBody",
            "You keep ownership of photos, text and other material you submit. The licence you grant the club and Ping4All is only the one in the Terms of use: to run SmartTT for your club, and only with the consents that apply to video, heart rate and public image. This EULA does not grant Ping4All a perpetual right to use your image or voice for advertising."
          )}
        </p>

        <h2>{t("eulaConductTitle", "In-app communication")}</h2>
        <p>
          {t(
            "eulaConductBody",
            "If the app includes chat or messages, do not abuse, threaten, harass, spam, impersonate, or collect other people's personal data. Ping4All is not responsible for what other users send."
          )}
        </p>

        <h2>{t("eulaWarrantyTitle", "Warranty and liability")}</h2>
        <p>
          {t(
            "eulaWarrantyBody",
            "The app is provided as is and as available. Liability, indemnity, changes, and Luxembourg law (including 60 days of good-faith discussion) are the same as in the Terms of use."
          )}
        </p>

        <p>
          {t("eulaContact", "Questions:")}{" "}
          <a href={`mailto:${PRIVACY_CONTACT}`}>{PRIVACY_CONTACT}</a>
        </p>
        <p className="terms-page__full">
          <Link to="/Termsofuse">{t("terms", "Terms of use")}</Link>
          {" · "}
          <Link to="/privacy">{t("privacyPolicy", "Privacy notice")}</Link>
        </p>
        <LegalFooter />
      </article>
    </div>
  );
}
